import '../Scss/main.scss';

import { initializeAccordion } from './components/accordion.js';
import { initializeContactModul } from './components/contact-modul.js';
import { initStreamSlider } from './components/slider-img.js';
//import { toTopScroll } from './components/to-top-scroll.js';
//import { initializeSlider } from './components/slider.js';
import { navigationMobile }  from './components/mobile-navigation.js';
//import { navigationHide } from "./components/navigationHide.js";




// initialize all Components after document is ready
$(document).ready(function() {
    initializeAccordion();
    initializeContactModul();
    initStreamSlider();
    navigationMobile();
});
